import View from '../../../js/View'
import $ from 'jquery'
import AddonsMenu from '../../../js/support/addons/AddonsMenu'
import {connect} from '../../../js/redux/utils'
import {bindActionCreators} from 'redux'
import {isAddonsMenuShown, isShowAtIntegrationAction} from './selectors'
import {closeAddonsMenu, toggleAddonsMenu} from './actions'
import DropdownDialogWithPointerWrapper from '../../../js/components/DropdownDialogWithPointerWrapper'
import AddonCard from '../../../js/support/addons/AddonCard'
import {PRODUCT_SWITCHER_URL} from '../../../js/constants'
import {isOtherProductLicenseExpired, isOtherProductLicenseViolated} from '../../../js/activeLicenseInfo/selectors'
import {AddonsCardsModels, AddonsMenuActionUrls} from '../../../js/support/addons/constants'
import MobileAppButtons from '../../../js/support/addons/MobileAppButtons'

class AddonsMenuContainer extends View {
    constructor({
        toggleAddonsMenu = () => {},
        closeAddonsMenu = () => {},
    } = {}) {
        super()

        this.actions = {
            toggleAddonsMenu,
            closeAddonsMenu,
        }

        this.state = {
            shown: false,
            isShowAtIntegrationAction: false,
            isAtExpired: false,
            isAtViolated: false,
        }

        this.onStatePropertyChanged('shown', shown => {
            if (shown) {
                this.addonsMenuDialog.showAt($('.popup_menu_button_addons'))
            } else {
                this.addonsMenuDialog.hide(true)
            }
        })

        this.onStatePropertyChanged('isShowAtIntegrationAction', isShowAtIntegrationAction => {
            this.atIntegrationCard.setState({
                showActionButton: isShowAtIntegrationAction,
            })
        })

        this.onAnyStatePropertyChanged(['isAtExpired', 'isAtViolated'], () => {
            this.atIntegrationCard.setState({
                showWarning: this.state.isAtExpired || this.state.isAtViolated,
                isExpired: this.state.isAtExpired,
            })
            this.$alertIcon.toggle(this.state.isAtExpired || this.state.isAtViolated)
        })
    }

    afterRender() {
        $('#popup_menu_button_addons')
            .mousedown(e => e.stopPropagation())
            .click(() => this.actions.toggleAddonsMenu())

        this.$alertIcon = $('.topMenuButton.addons .alertIcon')

        const openIntegrationPopup = () => {
            this.addonsMenuDialog.hide()
            window.openApIntegrationPopup()
        }
        this.atIntegrationCard = new AddonCard({
            ...AddonsCardsModels.AT_INTEGRATION,
            actionButtonTextKey: PRODUCT_SWITCHER_URL
                                 ? 'menu.addons.item.actitime.switch_button'
                                 : 'menu.addons.item.actitime.enable_button',
            onActionButtonClick: () => {
                if (PRODUCT_SWITCHER_URL) {
                    window.location.href = window.unescapeHtmlSymbols(PRODUCT_SWITCHER_URL)
                } else {
                    openIntegrationPopup()
                }
            },
            onDetailsButtonClick: openIntegrationPopup,
            onLinkClickCallback: () => this.addonsMenuDialog.hide(),
        })

        this.mobileCard = new AddonCard({
            ...AddonsCardsModels.MOBILE,
            additionalIconClass: 'apMobileAppIcon',
            customButtonComponent: new MobileAppButtons({
                onIosButtonClick: () => this.openUrl(AddonsMenuActionUrls.AP_MOBILE_IOS_ACTION_URL),
                onAndroidButtonClick: () => this.openUrl(AddonsMenuActionUrls.AP_MOBILE_ANDROID_ACTION_URL)
            }),
            onLinkClickCallback: () => this.addonsMenuDialog.hide(),
        })

        this.addonsMenu = new AddonsMenu({
            additionalClass: 'apAddonsMenu',
            integrationComponents: [this.atIntegrationCard],
            mobileComponents: [this.mobileCard],
        })
        this.addonsMenuDialog = new DropdownDialogWithPointerWrapper({
            dialog: this.addonsMenu,
            additionalClass: 'addonsMenuDropdownDialog',
            showAnimationClass: 'popup_menu_slide_down',
            hideAnimationClass: 'popup_menu_slide_up',
            onHide: this.actions.closeAddonsMenu,
            pointerLeftOffset: '-10px',
            dialogOffsets: {
                left: -80,
                top: 8
            }
        }).init($('body'))
    }

    openUrl(url) {
        this.addonsMenuDialog.hide()
        window.open(url)
    }
}

export default connect(
    (state) => ({
        shown: isAddonsMenuShown(state),
        isShowAtIntegrationAction: isShowAtIntegrationAction(state),
        isAtExpired: isOtherProductLicenseExpired(state),
        isAtViolated: isOtherProductLicenseViolated(state),
    }),
    (dispatch) => ({
        toggleAddonsMenu: bindActionCreators(toggleAddonsMenu, dispatch),
        closeAddonsMenu: bindActionCreators(closeAddonsMenu, dispatch),
    })
)(AddonsMenuContainer)



// WEBPACK FOOTER //
// ./web/actiplans/js/addons/AddonsMenuContainer.js